var html = document.documentElement;
var body = document.body;

responsiveNav();
video();

function responsiveNav() {
	const menuContainer = document.querySelector('.menu-container');
	const menuButton = document.querySelector('.menu-button');
	const navMenu = document.querySelector('.menu-nav');
	const socialMenu = document.querySelector('.menu-social');

	// Add a click event listener to the menu button
	menuButton.addEventListener('click', () => {
		// Toggle the "hidden" class on the navigation menu
		menuContainer.classList.toggle('full-screen');
		navMenu.classList.toggle('hidden');
		socialMenu.classList.toggle('hidden');

		html.classList.toggle('overflow-hidden');
		body.classList.toggle('overflow-hidden');
	});
}

function video() {
		'use strict';
		const sources = [
				'.single-content iframe[src*="youtube.com"]',
				'.single-content iframe[src*="youtube-nocookie.com"]',
				'.single-content iframe[src*="player.vimeo.com"]',
				'.single-content iframe[src*="kickstarter.com"][src*="video.html"]',
				'object',
				'embed',
		];

		reframe(document.querySelectorAll(sources.join(',')));
}
